import type { OperatingSchedule, OperatingStatus, WorldClock } from '../../domain/types.js';
import { worldTimezone } from '../worldRuntime/clock.js';

/** Notes §12 — `Sun, Sep 20, 5:58pm, 1 char, closed|live`. */
export function formatAquariumSubtitle(
  clock: WorldClock,
  schedule: OperatingSchedule,
  charCount: number,
  operatingStatus: OperatingStatus,
): string {
  const d = new Date(clock.inWorldIso);
  if (Number.isNaN(d.getTime())) {
    return `${charCount} char, ${operatingStatus === 'open' ? 'live' : 'closed'}`;
  }
  const tz = worldTimezone(schedule);
  const weekday = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short' }).format(d);
  const month = new Intl.DateTimeFormat('en-US', { timeZone: tz, month: 'short' }).format(d);
  const day = new Intl.DateTimeFormat('en-US', { timeZone: tz, day: 'numeric' }).format(d);
  const timeRaw = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(d);
  const time = timeRaw.replace(/\s/g, '').toLowerCase();
  const state = operatingStatus === 'open' ? 'live' : 'closed';
  return `${weekday}, ${month} ${day}, ${time}, ${charCount} char, ${state}`;
}
